(function () {

  function removeBubble() {
    const bubble = document.querySelector("#face-age-message-bubbles");
    if (bubble) {
      bubble.remove();
    }
  }

  function init() {
    // İlk deneme
    removeBubble();

    // Face Age sonradan inject ederse tekrar sil
    const observer = new MutationObserver(removeBubble);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();